import { DFP_BANNER } from 'enums/banners/dfp-banner'
import { printScssBannerSettings } from '@/utils/helpers/banners'

/**
 * This breakpoint was introduced by the requirement to display sky banners of 160px width where
 * it is possible considering the obligatory 50px of distance between banner and the content.
 * It was decided not to put this breakpoint into "breakpoint" enum since it is only related
 * to sky banners.
 */
export const WIDE_SKY_BANNERS_BREAKPOINT_NAME = 'wide-sky-banners'
export const WIDE_SKY_BANNERS_BREAKPOINT_VALUE = 1970

export const getInsideListMpuBannerSettingsKey = number => `MPU_${number}`

const TOP_SIDE = {
  tablet: DFP_BANNER.TOP_SIDE_750x250,
  desktopSm: DFP_BANNER.TOP_SIDE_980x250,
  desktopMd: DFP_BANNER.TOP_SIDE_1140x250,
  desktopLg: DFP_BANNER.TOP_SIDE_1140x250,
  desktopXl: DFP_BANNER.TOP_SIDE_1140x250,
  aboveDesktopXl: DFP_BANNER.TOP_SIDE_1140x250,
  [WIDE_SKY_BANNERS_BREAKPOINT_NAME]: DFP_BANNER.TOP_SIDE_1140x250
}

const RIGHT_SIDE_1 = {
  tablet: DFP_BANNER.RIGHT_SIDE_1_250x360,
  desktopSm: DFP_BANNER.RIGHT_SIDE_1_250x360,
  desktopMd: DFP_BANNER.RIGHT_SIDE_1_250x360,
  desktopLg: DFP_BANNER.RIGHT_SIDE_1_250x360,
  desktopXl: DFP_BANNER.RIGHT_SIDE_1_250x360,
  aboveDesktopXl: DFP_BANNER.RIGHT_SIDE_1_250x360
}

const RIGHT_SIDE_2 = {
  tablet: DFP_BANNER.RIGHT_SIDE_2_250x360,
  desktopSm: DFP_BANNER.RIGHT_SIDE_2_250x360,
  desktopMd: DFP_BANNER.RIGHT_SIDE_2_250x360,
  desktopLg: DFP_BANNER.RIGHT_SIDE_2_250x360,
  desktopXl: DFP_BANNER.RIGHT_SIDE_2_250x360,
  aboveDesktopXl: DFP_BANNER.RIGHT_SIDE_2_250x360
}

const MPU_1 = {
  mobile: DFP_BANNER.MPU_1_250x250
}

const MPU_2 = {
  mobile: DFP_BANNER.MPU_2_250x250
}

const MPU_3 = {
  mobile: DFP_BANNER.MPU_3_250x250
}

const START_TRADING = {
  mobile: DFP_BANNER.START_TRADING_240x40,
  tablet: DFP_BANNER.START_TRADING_240x40,
  desktopSm: DFP_BANNER.START_TRADING_240x40,
  desktopMd: DFP_BANNER.START_TRADING_240x40,
  desktopLg: DFP_BANNER.START_TRADING_240x40,
  desktopXl: DFP_BANNER.START_TRADING_240x40,
  aboveDesktopXl: DFP_BANNER.START_TRADING_240x40
}

export const BANNER_SETTINGS = {
  HOMEPAGE: {
    TOP_SIDE,
    RIGHT_SIDE_1,
    RIGHT_SIDE_2,
    START_TRADING,
    MPU_1,
    MPU_2,
    MPU_3
  },
  LIVE_FEED: {
    TOP_SIDE,
    RIGHT_SIDE_1,
    RIGHT_SIDE_2,
    MPU_1,
    MPU_2,
    MPU_3
  },
  ARTICLE: {
    TOP_SIDE,
    RIGHT_SIDE_1,
    RIGHT_SIDE_2,
    MPU_1,
    MPU_2,
    MPU_3,
    START_TRADING
  },
  SIDEBAR: {
    RIGHT_SIDE_1,
    RIGHT_SIDE_2,
    START_TRADING
  },
  RSS: {
    TOP_SIDE,
    RIGHT_SIDE_1,
    RIGHT_SIDE_2,
    MPU_1,
    START_TRADING
  },
  CONTACT_US: {
    TOP_SIDE,
    RIGHT_SIDE_1,
    RIGHT_SIDE_2
  },
  TERMS: {
    MPU_1,
    MPU_2,
    MPU_3
  },
  TERMS_HP: {
    TOP_SIDE,
    RIGHT_SIDE_1,
    RIGHT_SIDE_2
  },
  TERMS_LETTER: {
    TOP_SIDE,
    RIGHT_SIDE_1,
    RIGHT_SIDE_2
  },
  SEARCH_RESULTS: {
    TOP_SIDE,
    RIGHT_SIDE_1,
    RIGHT_SIDE_2
  },
  TAG_PAGE: {
    TOP_SIDE,
    RIGHT_SIDE_1,
    RIGHT_SIDE_2,
    MPU_1,
    MPU_2
  },
  TAG_SEARCH_RESULTS: {
    TOP_SIDE,
    RIGHT_SIDE_1,
    RIGHT_SIDE_2
  },
  TERM_PAGE: {
    TOP_SIDE,
    RIGHT_SIDE_1,
    RIGHT_SIDE_2,
    MPU_1
  },
  TERMS_SEARCH_RESULTS: {
    TOP_SIDE,
    RIGHT_SIDE_1,
    RIGHT_SIDE_2
  },
  LIVE_CHARTS: {
    TOP_SIDE,
    RIGHT_SIDE_1,
    RIGHT_SIDE_2,
    MPU_1,
    MPU_2,
    MPU_3
  },
  LIVE_QUOTES: {
    TOP_SIDE,
    RIGHT_SIDE_1,
    RIGHT_SIDE_2,
    MPU_1,
    MPU_2,
    MPU_3
  },
  ECONOMIC_CALENDAR: {
    TOP_SIDE,
    RIGHT_SIDE_1,
    RIGHT_SIDE_2,
    MPU_1,
    MPU_2,
    MPU_3
  },
  AUTHOR_PAGE: {
    TOP_SIDE,
    MPU_1
  },
  CATEGORY: {
    TOP_SIDE,
    RIGHT_SIDE_1,
    RIGHT_SIDE_2,
    MPU_1,
    MPU_2
  },
  DIRECTORY_CATEGORY: {
    TOP_SIDE,
    MPU_1
  },
  DIRECTORY_COMPANY: {
    TOP_SIDE,
    RIGHT_SIDE_1,
    RIGHT_SIDE_2
  },
  EDUCATION: {
    TOP_SIDE,
    RIGHT_SIDE_1,
    RIGHT_SIDE_2,
    MPU_1,
    MPU_2,
    MPU_3
  },
  BECOME_AN_AUTHOR: {
    TOP_SIDE,
    RIGHT_SIDE_1,
    RIGHT_SIDE_2
  },
  ABOUT: {
    TOP_SIDE,
    RIGHT_SIDE_1,
    RIGHT_SIDE_2,
    MPU_1,
    MPU_2,
    MPU_3
  },
  PERSONAL_AREA: {
    TOP_SIDE
  },
  PREMIUM: {
    TOP_SIDE
  },
  COMPANY_COMPARE: {
    TOP_SIDE
  }
}

const isDevelopment = process.env.NODE_ENV === 'development'
if (isDevelopment && process.client) {
  printScssBannerSettings(BANNER_SETTINGS)
}

// /** The code below allows to verify all the needed banners class names **/
// /* eslint-disable */
// const bannerClassesSet = new Set()
// const BANNER_CLASSES = Object.entries(BANNER_SETTINGS).reduce(
//   (acc, [page, pageSettings]) => ({
//     ...acc,
//     [page]: Object.entries(pageSettings).reduce(
//       (acc, [banner, bannerSettings]) => ({
//         ...acc,
//         [banner]: Object.entries(bannerSettings).reduce(
//           (acc, [breakpoint, breakpointBannerSetting]) => {
//             const [bannerWidth, bannerHeight] = breakpointBannerSetting.sizes
//
//             const className = `${breakpoint}_${bannerWidth}${
//               bannerHeight ? `x${bannerHeight}` : ''
//             }`
//             bannerClassesSet.add(className)
//
//             return `${acc} ${className}`
//           },
//           ''
//         )
//       }),
//       {}
//     )
//   }),
//   {}
// )
// console.log('allUniqueBannerClasses', bannerClassesSet)
